import { maLookback } from '../../math/ma'
import { COLOR, float, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'BBWIDTH',
  version: 1,
  label: 'Bollinger Bandwidth',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 4,
  order: 320,
  inputs: [period('timeperiod', 20), float('nbdevup', 2, 'StdDev up', 0, 100, 0.1), float('nbdevdn', 2, 'StdDev down', 0, 100, 0.1), matype()],
  outputs: [line('width', 'Bandwidth', COLOR.teal)],
  // Undefined (NaN) on a bar whose middle band is exactly 0.
  talib: {
    functions: ['BBANDS'],
    expr: '(upperband - lowerband) / middleband where upperband, middleband, lowerband = BBANDS(close, timeperiod={timeperiod}, nbdevup={nbdevup}, nbdevdn={nbdevdn}, matype={matype})',
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, matype }) => maLookback(timeperiod, matype),
}
export default def
